module.exports = __webpack_public_path__ + "img/alex_situations_grey.fb14d34b.svg";